module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00464.e24b251c.jpg";